import { useRouter } from 'found';
import React, { useEffect, useMemo, useRef } from 'react';
import { useApolloClient, useQuery } from '@apollo/client';
import Main from '../ripple/Containers/Main';
import { GET_PROFILE_INFO } from '../schema/apolloQueries/commonQueries';
import { GET_SURVEY_COLLECTORS } from '../schema/apolloQueries/getSurveyCollectors';

const Survey = () => {
  const {
    // router,
    match: {
      params: { surveyId },
    },
  } = useRouter();
  const divRef = useRef(null);
  const { data } = useQuery(GET_SURVEY_COLLECTORS, {
    variables: {
      surveyId,
    },
  });
  const survey = useMemo(() => {
    return data?.getSurveyCollectors;
  }, [data]);

  const popup = useMemo(() => survey?.collectors?.popup, [survey]);
  const client = useApolloClient();

  const profileData = useMemo(() => {
    return client.readQuery({
      query: GET_PROFILE_INFO,
    });
  }, [survey?.id]);

  const userId = profileData?.getProfile?.personInfo
    ? profileData?.getProfile?.personInfo.id
    : 0;

  const Url = useMemo(() => {
    if (popup) {
      const srcRegex = /src="(.*?)"/;

      // Extracting the src attribute value
      const match = srcRegex.exec(popup);

      // Checking if there is a match
      if (match) {
        const srcValue = match[1];
        return srcValue;
      }
    }
  }, [popup]);
  const customvariables = useMemo(() => {
    if (userId) {
      const custom_variable = [['custom_variable', 'personId', userId]];
      custom_variable.push(['custom_variable', 'deviceType', 'web']);
      return custom_variable;
    }
    return null;
  }, [userId]);

  useEffect(() => {
    if (Url && customvariables) {
      // Create the script element
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = Url;
      script.id = 'smcx-sdk';

      window.SMCX = [];
      window.SMCX.push(...customvariables);
      // Append the script to the div
      if (divRef.current) {
        divRef.current.appendChild(script);
      }

      // Cleanup script when component unmounts
      return () => {
        if (divRef.current) {
          divRef.current.removeChild(script);
        }
      };
    }
  }, [customvariables, Url]);

  return (
    <Main>
      <div ref={divRef} id='surveyMonkeyContainer' />
    </Main>
  );
};

export default Survey;
